import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    OnChanges,
    OnInit,
    SimpleChanges,
    input,
    output,
} from '@angular/core';

import { MediaModel } from '../../models/media.models';
import { MediaImageComponent } from '../media-image/media-image.component';
import { MediaSkeletonComponent } from '../media-skeleton/media-skeleton.component';
import { MediaVideoComponent } from '../media-video/media-video.component';

@Component({
    selector: 'product-media-skeleton',
    templateUrl: './product-media-skeleton.component.html',
    imports: [
        NgClass, MediaSkeletonComponent, MediaImageComponent, MediaVideoComponent, NgTemplateOutlet,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductMediaSkeletonComponent implements OnChanges, OnInit {
    public showVideo = false;

    public imageLoaded = false;

    public videoLoaded = false;

    // INPUT DATA
    public imageUrl = input.required<string>();

    public mediaConfig = input.required<MediaModel>();

    public videoUrl = input<string>();

    public classes = input<string>();

    public hasInView = input<boolean>();

    // OUTPUT EVENTS
    public readonly mediaError = output<Event>();

    public readonly videoElementRendered = output<boolean>();

    public readonly hasAudio = output<boolean>();

    public readonly clickMedia = output<{ e: Event; imageUrl: string }>();

    public readonly sendVideoLoaded = output<boolean>();

    public ngOnInit(): void {
        if (!this.imageUrl() || this.mediaConfig()?.imagePriority) {
            this.imageLoaded = true;
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const img = changes.imageUrl;
        if (img && !img.isFirstChange() && img.currentValue !== img.previousValue) {
            this.showVideo = false;
            this.videoLoaded = false;
            this.imageLoaded = false;
        }
    }

    public onVideoLoad() {
        this.videoLoaded = true;
        this.sendVideoLoaded.emit(true);
    }

    public onImageError(event) {
        this.mediaError.emit(event);
        this.showVideo = true; // el error de la imagen no debe ser bloqueante para el video
    }

    public onClickMedia(event) {
        this.clickMedia.emit({ e: event, imageUrl: this.imageUrl() });
    }

    public onImageLoad(_event) {
        this.imageLoaded = true;
        this.showVideo = true;
    }

    public handleKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === ' ') {
            this.onClickMedia(event);
            event.preventDefault();
        }
    }

    public handleHlsError(event: string): void {
        this.imageLoaded = false;
        this.showVideo = false;
        this.mediaError.emit(event as any);
    }

    public sendHasAudio($event: boolean) {
        this.hasAudio.emit($event);
    }
}
